












































import _ from 'lodash'
import moment from 'moment'
import { Component } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { HodidayList, IHodiday, ISchedule, ScheduleList } from '@/store/modules/views/schedule/states'
import PatientDetail from '@/components/today/PatientDetail.vue'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { UserProfile } from '@/store/modules/views/userProfile/states'
import { IJob } from '@/store/modules/views/job/states'
import { ELevel } from '@/services/Menus'

@Component({
  components: {
    PatientDetail,
  },
})
export default class ScheduleConfirmation extends VueExtendedBaseComponent {
  private loading = false
  private schedule: ISchedule

  @Getter('userprofile/getProfile')
  private profile!: UserProfile

  @Getter('schedule/scheduleByUserLists')
  private scheduleByUserLists!: ISchedule

  @Getter('schedule/holidayLists')
  private holidayLists!: HodidayList

  @Getter('job/jobById')
  private jobById!: IJob

  get jobId() {
    return this.$route.params.status || ''
  }

  get allScheduleByUser() {
    return this.scheduleByUserLists ? this.scheduleByUserLists : []
  }

  get mapSchedule() {
    return _.map(this.allScheduleByUser, (item: ISchedule) => {
      const startDateTime = this.doConvertDateTimeZone(item.startDate, item.startTime, 'T00:')
      const endDateTime = this.doConvertDateTimeZone(item.endDate, item.endTime, 'T23:')
      return {
        _id: item._id,
        name: `${item.startTime}น. - ${item.endTime}น.`,
        start: startDateTime,
        end: endDateTime,
        color: item.jobId === this.jobId && item.status === 'รอรับงาน' ? 'secondary' : 'grey',
        timed: moment(startDateTime).diff(moment(endDateTime), 'days') === 1,
        isDialog: true,
      }
    })
  }

  get mapExcludeDate() {
    return this.profile && this.profile.metadata && this.profile.metadata.excludeDate
      ? _.map(this.profile.metadata.excludeDate, (item) => {
        const startDateTime = this.doConvertDateTimeZone(item)
        const endDateTime = this.doConvertDateTimeZone(item)
        return {
          name: `วันหยุด`,
          start: startDateTime,
          end: endDateTime,
          color: moment(startDateTime).diff(moment(), 'days') < 0 ? 'grey' : 'red darken-2',
          timed: moment(startDateTime).diff(moment(endDateTime), 'days') === 1,
          isDialog: false,
        }
      })
      : []
  }

  get mapHoliday() {
    return !_.isNil(this.holidayLists) && !_.isEmpty(this.holidayLists)
      ? _.map(this.holidayLists.data, (item: IHodiday) => {
          const startDateTime = this.doConvertDateTimeZone(item.date)
          const endDateTime = this.doConvertDateTimeZone(item.date)
          return {
            _id: item._id,
            name: item.name,
            start: startDateTime,
            end: endDateTime,
            color: moment(startDateTime).diff(moment(), 'days') < 0 ? 'grey' : 'info',
            timed: moment(startDateTime).diff(moment(endDateTime), 'days') === 1,
            isDialog: false,
          }
        })
      : []
  }

  get events() {
    return _.concat(this.mapExcludeDate, this.mapSchedule, this.mapHoliday)
  }

  @Action('components/updateTitlePage')
  private updateTitlePage!: (title: string) => void

  @Action('schedule/getScheduleListByUser')
  private getScheduleListByUser!: (options: {}) => void

  @Action('schedule/getHodidayList')
  private getHodidayList!: (options: {}) => ScheduleList

  @Action('schedule/putScheduleStatus')
  private putScheduleStatus!: (options) => void

  @Action('job/getJobById')
  private getJobById!: (options: {}) => void

  private async mounted() {
    this.$store.dispatch('components/setLevel', {id: this.profile._id, mode: ELevel.USER})
    this.updateTitlePage('ยืนยันตารางงาน')
    this.loading = true
    await Promise.all([
      this.getHodidayList({}),
      this.getScheduleListByUser({}),
    ])
    const watingConfirmJob = _.find(this.allScheduleByUser, (item: ISchedule) => item.status === 'รอรับงาน')
    if (_.isUndefined(watingConfirmJob)) {
      this.$router.push('/action/profile')
      this.updateSnackbar({ txt: 'ไม่มีข้อมูลงานที่รอตรวจสอบ', type: 'error' })
    }
    await this.getJobById({ _id: this.$route.params.status })
    this.loading = false
  }

  private async doCancel() {
    this.loading = true
    const data = {
      id: this.jobId,
      confirm: false,
    }
    try {
      await this.putScheduleStatus(data)
      this.updateSnackbar({txt: 'ปฏิเสธงานสำเร็จ', type: 'success'})
      this.loading = false
      this.$router.push(`/main/schedule`)
    } catch (error) {
      this.loading = false
    }
  }

  private async doConfirm() {
    this.loading = true
    const data = {
      id: this.jobId,
      confirm: true,
    }
    try {
      await this.putScheduleStatus(data)
      this.updateSnackbar({txt: 'ยอมรับงานสำเร็จ', type: 'success'})
      this.loading = false
      this.$router.push(`/main/schedule`)
    } catch (error) {
      this.loading = false
    }
  }
}
